import React, { useEffect } from "react";
import { buildVersion } from "../services/buildInfo";
import TrackingScripts from "../components/TrackingScripts";

function ThankYou() {

  // Adobe DataLayer (KEPT)
  useEffect(() => {
    window.adobeDataLayer = window.adobeDataLayer || [];
    window.adobeDataLayer.push({
      "event": "pageView",
      "web": {
        "webPageDetails": {
          "pageViews": {
            "value": 1
          },
          "name": "icicibank:in:en:campaign:accounts:casa:salcorpsavingsaccount:onboarding:eligible thankyou page",
          "URL": window.location.href,
          "isErrorPage": "False",
        }
      },
      "_icicibank": {
        "channelInfo": {
          "version": buildVersion,
          "name": "nli",
        },
        "pageInfo": {
          "language": "en",
          "country": "in",
          "pageType": "campaign",
          "virtualPageView": "no vpv",
          "journey": "na",
          "subJourney": "na",
          "subSubJourney": "na",
        },
        "userInfo": {
          "userType": "na"
        },
        "errorInfo": {
          "errorType": "na",
          "errorDetails": "na"
        }
      }
    });
  }, []);


  return (
    <>
      <TrackingScripts />
      <article className="thankyou_sec">
        <div className="container ">
          <div className="tick">
            <img
              src="../dist/img/tick.webp"
              alt="tick"
              width="100"
              height="100"
              className="img-fluid"
            />
          </div>
          <div className="thankyou_txt">
            <p>
              Thank you for your interest in <br className="d-block" /> ICICI 3-in-1 Salary Account.&nbsp;
              <br className="d-md-none d-block" /> Your details have been submitted successfully.
              <br className="d-block" /> Our representative will get in touch with you shortly from a number starting with 1600 31 XXXX.
            </p>
          </div>
        </div>
      </article>
    </>
  );
}

export default ThankYou;
